import Vue from 'vue'
import VueLocalStorage from 'vue-ls'
import App from './App.vue'
import router from './router'
import Element from 'element-ui'
import global from '@/utils/index'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/reset.css'
import './styles/index.scss'
import '@/permission'
import MyVue from '@/components';
import common from '@/utils/common'
import './styles/element-variables.scss'
require('es6-promise').polyfill()
Vue.use(VueLocalStorage);
Vue.use(Element, { size: 'medium' });
Vue.use(MyVue);
Vue.config.productionTip = false
for (var k in global) {
  Vue.prototype[k] = global[k];
}
new Vue({ // eslint-disable-line
  el: '#app',
  router,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js